export default [
  { value: 'English', code: 'en' },
  { value: 'Italian', code: 'it' },
  { value: 'Japanese', code: 'ja' },
  { value: 'Dutch', code: 'nl' },
  { value: 'Greek', code: 'el' },
  { value: 'French', code: 'fr' },
  { value: 'Macedonian', code: 'mk' }
];
